import {
  ACCOUNTTYPE,
  BaseCssConfig,
  Constants,
  WidgetNames,
  WidgetTitles,
  WorkflowWidgetConfig,
  cryptoRandomUUID,
} from '@finxone-platform/shared/sys-config-types';
import { editBeneficaryIntlNestedWidgets } from '../nested-widgets/beneficiary/beneficiary';
import { addBeneficiaryIntlWidget, defaultInputCssConfig } from '../payments/payments.type';

export function getIntlCurrencyCountryWidgetConfigEditBeneficairy(
  intlCurrencyCountryWidgetConfig: WorkflowWidgetConfig,
): WorkflowWidgetConfig {
  const widgetConfig = intlCurrencyCountryWidgetConfig;
  widgetConfig.name = WidgetNames.EDIT_BENEFICIARY_INTERNATIONAL_CURRENCY_COUNTRY;
  widgetConfig.uniqueId = WidgetNames.EDIT_BENEFICIARY_INTERNATIONAL_CURRENCY_COUNTRY;
  widgetConfig.widgetConfiguration.nestedWidgets = {};
  return widgetConfig;
}

export function getIntlNewCurrencyCountryWidgetConfigEditBeneficiary(
  intlCurrencyCountryWidgetConfig: WorkflowWidgetConfig,
): WorkflowWidgetConfig {
  const widgetConfig = intlCurrencyCountryWidgetConfig;
  widgetConfig.name = WidgetNames.EDIT_BENEFICIARY_INTL_NEW_CURRENCY_COUNTRY;
  widgetConfig.uniqueId = WidgetNames.EDIT_BENEFICIARY_INTL_NEW_CURRENCY_COUNTRY;
  widgetConfig.widgetConfiguration.nestedWidgets = {};
  return widgetConfig;
}

export function getIntlEditBeneficiaryWidgetConfig(type: ACCOUNTTYPE): WorkflowWidgetConfig {
  const widgetConfig = addBeneficiaryIntlWidget(type);
  widgetConfig.name = WidgetNames.EDIT_BENEFICIARY_INTL_WIDGET;
  widgetConfig.widgetConfiguration.widgetConfigDisplayName = WidgetTitles.EDIT_BENEFICIARY_INTL_WIDGET;
  return widgetConfig;
}

export function getEditIntlBeneficiaryCredentialsWidget(
  type: 'business' | 'personal',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  override?: any,
): WorkflowWidgetConfig {
  const addIntlBeneficiaryCredentialsWidget: WorkflowWidgetConfig = {
    widgetTypeConfig: 'new',
    uniqueId: cryptoRandomUUID(),
    name: WidgetNames.EDIT_INTERNATIONAL_BENEFICIARY_CREDENTIALS_WIDGET,
    widgetConfiguration: {
      isRemovable: false,
      widgetDisplayName: '',
      widgetConfigDisplayName: WidgetTitles.INTERNATIONAL_BENEFICIARY_CREDENTIALS_WIDGET,
      nestedWidgets: editBeneficaryIntlNestedWidgets,
      attributes: {
        widgetProperties: {
          textContent: '',
          beneficiaryType: type,
          name: 'Full Name',
          bankName: 'Bank Name',
          firstName: 'First Name',
          lastName: 'Last Name',
          accountNumber: 'Account Number',
          iban: 'IBAN',
          aba: 'ABA Routing Number',
          bic: 'SWIFT/BIC Code',
          'rtn-canada': 'RTN',
          'sort-code': 'Sort Code',
          'bsb-code': 'BSB Number',
          ifsc: 'IFSC  Code',
          'bank-code': 'Bank Code',
          'branch-code': 'Branch Code',
          cnaps: 'CNAPS',
          clabe: 'CLABE',
          sortCodeLabel: 'Sort Code',
          buttonContent: 'Proceed',
          inputFieldSettings: {
            css_config: defaultInputCssConfig,
          },
        },
        elementsConfig: [],
        css_config: Constants.defaultBaseCssConfig,
      },
    },
    gridPosition: {
      x: 0,
      y: 9,
      rows: 10,
      cols: 15,
      dragEnabled: true,
      resizeEnabled: true,
      ...override?.gridPosition,
    },
    widgetIconPath: '',
  };
  return addIntlBeneficiaryCredentialsWidget;
}

export const addIntlBeneficiaryCredentialsWidget: WorkflowWidgetConfig = {
  widgetTypeConfig: 'new',
  uniqueId: WidgetNames.EDIT_INTERNATIONAL_BENEFICIARY_CREDENTIALS_WIDGET,
  name: WidgetNames.EDIT_INTERNATIONAL_BENEFICIARY_CREDENTIALS_WIDGET,
  widgetConfiguration: {
    isRemovable: false,
    widgetDisplayName: '',
    widgetConfigDisplayName: WidgetTitles.INTERNATIONAL_BENEFICIARY_CREDENTIALS_WIDGET,
    nestedWidgets: {
      previousButton: {
        name: WidgetNames.BUTTON,
        widgetConfigDisplayName: 'Previous Button Styling',
        attributes: {
          widgetProperties: {
            textContent: 'Previous',
          },
          elementsConfig: [],
          css_config: {
            ...Constants.defaultUiNestedButtonCssConfig,
            backGroundColor: 'var(--palette-color-2)',
            color: 'var(--color-on-background)',
            borderWidth: 1,
            borderColor: 'var(--color-border-color)',
            borderStyle: 'solid',
            verticalAlignment: 'center',
            marginRight: 10,
            marginTop: 15,
          },
        },
      },

      nextButton: {
        name: WidgetNames.BUTTON,
        widgetConfigDisplayName: 'Next Button Styling',
        attributes: {
          widgetProperties: {
            textContent: 'Next',
          },
          elementsConfig: [],
          css_config: {
            ...Constants.defaultUiNestedButtonCssConfig,
            backGroundColor: 'var(--palette-color-2)',
            color: 'var(--color-on-background)',
            borderWidth: 1,
            borderColor: 'var(--color-border-color)',
            borderStyle: 'solid',
            verticalAlignment: 'center',
            marginTop: 15,
            marginLeft: 10,
          },
        },
      },
    },
    attributes: {
      widgetProperties: {
        textContent: '',
        beneficiaryType: 'personal',
        name: 'Full Name',
        bankName: 'Bank Name',
        firstName: 'First Name',
        lastName: 'Last Name',
        accountNumber: 'Account Number',
        iban: 'IBAN',
        aba: 'ABA Routing Number',
        bic: 'SWIFT/BIC Code',
        'rtn-canada': 'RTN',
        'sort-code': 'Sort Code',
        'bsb-code': 'BSB Number',
        ifsc: 'IFSC  Code',
        'bank-code': 'Bank Code',
        'branch-code': 'Branch Code',
        cnaps: 'CNAPS',
        clabe: 'CLABE',
        sortCodeLabel: 'Sort Code',
        buttonContent: 'Proceed',
        inputFieldSettings: {
          css_config: defaultInputCssConfig,
        },
      },
      elementsConfig: [],
      css_config: Constants.defaultBaseCssConfig,
    },
  },
  gridPosition: {
    x: 0,
    y: 9,
    rows: 10,
    cols: 15,
    dragEnabled: true,
    resizeEnabled: true,
  },
  widgetIconPath: '',
};

export function getEditIntlBeneficiaryAddressWidget(override: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  gridPosition?: any;
  css_config: BaseCssConfig;
}): WorkflowWidgetConfig {
  const intlBeneficiaryAddressWidget: WorkflowWidgetConfig = {
    widgetTypeConfig: 'new',
    uniqueId: WidgetNames.EDIT_INTL_BENEFICIARY_ADDRESS,
    name: WidgetNames.EDIT_INTL_BENEFICIARY_ADDRESS,
    widgetConfiguration: {
      isRemovable: false,
      widgetDisplayName: '',
      widgetConfigDisplayName: WidgetTitles.INTL_BENEFICIARY_ADDRESS_WIDGET,
      nestedWidgets: {},
      attributes: {
        css_config: Constants.defaultBaseCssConfig,
        widgetProperties: {
          textContent: '',
          enableAddress2: true,
          enableAddress3: true,
          enableAddress4: true,
          streetLabel: 'Street',
          addressLine1: 'Address line 1',
          addressLine2: 'Address line 2',
          addressLine3: 'Address line 3',
          addressLine4: 'Address line 4',
          cityLabel: 'City',
          stateRegionLabel: 'State/Region',
          countryLabel: 'Country',
          zipPostalLabel: 'Postal code',
        },
        elementsConfig: [],
      },
    },
    gridPosition: {
      x: 0,
      y: 4,
      rows: 22,
      cols: 15,
      dragEnabled: true,
      resizeEnabled: true,
      ...override?.gridPosition,
    },
    widgetIconPath: '',
  };
  return intlBeneficiaryAddressWidget;
}
